import PullDirectionBall from './PullDirectionBall';
import { t } from 'utilities/TranslationUtils';
import './PullDirectionCard.css';

type Props = {
  /** Pull direction in degrees; null renders the empty placeholder. */
  pullDirection: number | null;
  /** Optional spin-axis angle (deg) — draws the dashed axis line when present. */
  spinAxis?: number | null;
};

/**
 * Labelled pull-direction indicator: title, spinning ball (with arrow + optional axis) and the
 * rounded value. Colours inherit from the parent (`currentColor`), so the same component drops into
 * both the dark kick modal and the light measurement-detail page. Shared by both so the ball, its
 * rotation maths and the value formatting live in exactly one place.
 */
const PullDirectionCard = ({ pullDirection, spinAxis = null }: Props): React.ReactElement => (
  <div
    className={`pull-direction-card${pullDirection == null ? ' pull-direction-card--empty' : ''}`}
    // Hover explains the empty state: the value is withheld when the radar reports it with reduced accuracy.
    title={pullDirection == null ? t('sessions.pullDirectionUnavailable') : undefined}
  >
    <span className='pull-direction-card__label'>{t('sessions.kickDetailPullDirection')}</span>
    <div className='pull-direction-card__ball'>
      <PullDirectionBall pullDirection={pullDirection} spinAxis={spinAxis} emptyBall />
    </div>
    <span className='pull-direction-card__value'>
      {pullDirection != null ? `${Math.round(pullDirection)} ${t('common.unitDegrees')}` : '—'}
    </span>
  </div>
);

export default PullDirectionCard;
